<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Member Delete Feed</p>
    </header>

    <section class="modal-card-body">
      <article class="message is-small">
        <div class="message-header">
          <p>File Upload Guidelines</p>
        </div>
        <div class="message-body">
          <div class="content">
            <ul>
              <li>
                The only accepted file format is CSV.
                <ul>
                  <li>
                    You can easily convert any Excel file to CSV from Excel.
                    <b-tooltip
                      position="is-bottom"
                      type="is-white"
                      size="is-large"
                      multilined
                    >
                      (Hover over for hint)
                      <template v-slot:content>
                        <img
                          src="https://cdn.tbybewell.com/images/images/How-to-export-csv.png"
                          alt="example"
                        />
                      </template>
                    </b-tooltip>
                  </li>
                </ul>
              </li>
              <li>
                The username field MUST be the first column.
              </li>
              <li>
                If your CSV file has a header row, please indicate that below.
                <ul>
                  <li>
                    If exported from Excel, it's always going to have a header
                    row, so only uncheck if you made a custom file and omitted
                    it.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  To avoid overloading our system, please refrain from making
                  too many requests at once.
                </strong>
                <ul>
                  <li>
                    You can combine multiple programs into a single file to
                    consolidate requests.
                  </li>
                </ul>
              </li>
              <li>
                You will receive an email when your request has been processed.
              </li>
            </ul>
          </div>
        </div>
      </article>

      <b-field>
        <b-switch v-model="hasHeaderRow" size="is-small">
          CSV has a header row
        </b-switch>
      </b-field>
      <b-field>
        <b-upload v-model="file" accept="text/csv" drag-drop expanded>
          <section class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large" />
              </p>
              <p>Drop CSV file here or click to upload</p>
            </div>
          </section>
        </b-upload>
      </b-field>

      <div class="tags">
        <span v-if="file" class="tag is-primary">
          {{ file.name }}
          <button
            class="delete is-small"
            type="button"
            @click="removeFileFromQueue()"
          ></button>
        </span>
      </div>
    </section>

    <footer class="modal-card-foot custom-modal-card-foot">
      <b-button type="text" @click.native="$parent.close()">
        Cancel
      </b-button>
      <b-button
        type="is-primary"
        :disabled="file === null"
        :loading="loading"
        @click="uploadFile()"
      >
        Upload File
      </b-button>
    </footer>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SuperAdminMemberDeleteFeed",

  data() {
    return {
      loading: false,
      hasHeaderRow: true,
      file: null
    };
  },
  methods: {
    ...mapActions("superAdmin", ["uploadUserDeleteFile"]),
    removeFileFromQueue() {
      this.file = null;
    },
    uploadFile() {
      this.loading = true;

      try {
        const formData = new FormData();

        formData.set("csvFile", this.file);
        formData.set("hasHeader", this.hasHeaderRow ? 1 : 0);

        this.uploadUserDeleteFile(formData)
          .then(response => {
            this.loading = false;

            if (response.status === 200) {
              this.$buefy.toast.open("Deletion Request Successfully Sent");
              this.$parent.close();
            } else {
              this.$buefy.toast.open("Failed to upload deletion feed.");
            }
          })
          .catch(e => {
            this.loading = false;

            this.$buefy.toast.open("Failed to upload deletion feed.");

            console.error(e);
          });
      } catch (e) {
        this.loading = false;
        this.$buefy.toast.open("Failed to upload deletion feed.");

        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss">
ul {
  list-style-type: disc;
}
ul ul li {
  margin-left: 1em;
}

li {
  font-weight: 300;
}

li strong {
  font-weight: 900;
}
</style>
